// Lead Disposition vocabulary + color map (per-prospect / per-contact status).
// Distinct from per-call dispositions in `dispositions.js`.
// MUST stay in sync with `/app/backend/config.py:LEAD_DISPOSITIONS`.

export const LEAD_DISPOSITIONS = [
  "New Lead",
  "Contacted",
  "Appointment Booked",
  "Quote Sent",
  "Sold/Won",
  "In Service",
  "Follow-Up Needed",
  "No Answer",
  "Not Interested",
  "DNC",
  "Wrong Number",
  "Duplicate",
];

export const DEFAULT_LEAD_DISPOSITION = "New Lead";

// Tailwind class bundles per disposition.
//   green   = Sold/Won + In Service (revenue)
//   sky     = booked
//   amber   = active pipeline (Contacted / Quote Sent / Follow-Up Needed)
//   gray    = dead ends (Not Interested / No Answer / Wrong Number / Duplicate)
//   red     = DNC (hard stop)
//   white   = New Lead (untouched)
export const LEAD_DISPOSITION_STYLES = {
  "New Lead":            { bg: "bg-white/5",        text: "text-white/60",    ring: "ring-white/10",       dot: "bg-white/30" },
  "Contacted":           { bg: "bg-amber-500/10",   text: "text-amber-400",   ring: "ring-amber-500/30",   dot: "bg-amber-400" },
  "Appointment Booked":  { bg: "bg-sky-500/10",     text: "text-sky-400",     ring: "ring-sky-500/30",     dot: "bg-sky-400" },
  "Quote Sent":          { bg: "bg-amber-500/10",   text: "text-amber-300",   ring: "ring-amber-500/30",   dot: "bg-amber-300" },
  "Sold/Won":            { bg: "bg-emerald-500/15", text: "text-emerald-400", ring: "ring-emerald-500/40", dot: "bg-emerald-400" },
  "In Service":          { bg: "bg-emerald-500/10", text: "text-emerald-300", ring: "ring-emerald-500/30", dot: "bg-emerald-300" },
  "Follow-Up Needed":    { bg: "bg-amber-500/10",   text: "text-amber-400",   ring: "ring-amber-500/30",   dot: "bg-amber-400" },
  "No Answer":           { bg: "bg-zinc-500/10",    text: "text-zinc-400",    ring: "ring-zinc-500/30",    dot: "bg-zinc-400" },
  "Not Interested":      { bg: "bg-zinc-500/10",    text: "text-zinc-400",    ring: "ring-zinc-500/30",    dot: "bg-zinc-400" },
  "DNC":                 { bg: "bg-red-500/15",     text: "text-red-400",     ring: "ring-red-500/40",     dot: "bg-red-500" },
  "Wrong Number":        { bg: "bg-zinc-500/10",    text: "text-zinc-400",    ring: "ring-zinc-500/30",    dot: "bg-zinc-400" },
  "Duplicate":           { bg: "bg-zinc-500/10",    text: "text-zinc-400",    ring: "ring-zinc-500/30",    dot: "bg-zinc-400" },
};

export const leadDispositionStyle = (d) =>
  LEAD_DISPOSITION_STYLES[d] || LEAD_DISPOSITION_STYLES["New Lead"];
